<template>
  <div class="container">
    <sys-loading :loading="loading" />
    <div v-if="!isMobile" class="content" @click="clickHandler($event)">
      <img class="gif-air" src="../assets/new-sport/gif-pc.gif" />
      <img class="btn-air" src="../assets/new-sport/btn-main.gif" />
      <div class="mask" v-show="formVisible">
        <div class="form">
          <img class="close" src="../assets/new-sport/icon-close.png" />
          <div class="form-content">
            <div class="tags">
              <img :class="!isRegisterAction ? 'active' : ''" v-show="isRegisterAction" src="../assets/new-sport/icon-login-n.png" @click="isRegisterAction = false" />
              <img :class="!isRegisterAction ? 'active' : ''" v-show="!isRegisterAction" src="../assets/new-sport/icon-login-a.png" @click="isRegisterAction = false" />
              <img :class="isRegisterAction ? 'active' : ''" v-show="isRegisterAction" src="../assets/new-sport/icon-reg-a.png" @click="isRegisterAction = true" />
              <img :class="isRegisterAction ? 'active' : ''" v-show="!isRegisterAction" src="../assets/new-sport/icon-reg-n.png" @click="isRegisterAction = true" />
            </div>
            <div class="inputs">
              <div class="success-show" v-if="successful">
                <img :src="
                    isRegisterAction
                      ? require('../assets/new-sport/success-reg.png')
                      : require('../assets/new-sport/success-login.png')
                  " />
                <p>
                  {{
                    isRegisterAction
                      ? "* Chúc mừng bạn đã đăng ký thành công! Tự động đăng nhập trong 5s."
                      : "* Bạn đang được chuyển về trang chủ 8day Vui lòng chờ trong 5s."
                  }}
                </p>
              </div>
              <div class="tao" v-if="!successful" :style="isRegisterAction ? '' : 'height: 43%;'">
                <el-form :model="form" ref="formClient">
                  <el-form-item prop="userName" :rules="userNameRule">
                    <el-input v-model="form.userName" placeholder="Tên đăng nhập" maxlength="20" oninput="value=value.replace(/\W/, '')" autocomplete="off"></el-input>
                  </el-form-item>
                  <el-form-item prop="phone" v-show="isRegisterAction" :rules="isRegisterAction ? phoneRule : null">
                    <el-input v-model="form.phone" placeholder="Số điện thoại" maxlength="11" oninput="value=value.replace(/\D/, '')"></el-input>
                  </el-form-item>
                  <el-form-item prop="password" :rules="passwordRule">
                    <el-input type="password" v-model="form.password" placeholder="Mật khẩu" autocomplete="off"></el-input>
                  </el-form-item>
                  <el-form-item prop="email" v-show="isRegisterAction" :rules="isRegisterAction ? emailRule : null">
                    <el-input v-model="form.email" placeholder="Email"></el-input>
                  </el-form-item>
                  <el-form-item prop="verificationCode" v-show="isRegisterAction" style="position: relative;">
                    <el-input style="background: #acfcef;border-radius: 10px;" v-model="form.verificationCode" maxlength="4"></el-input>
                    <div class="codeImg">
                      <span @click="getVerify" v-if="codeImg" class="validateCode">
                        <img class="img" :src="codeImg" alt="code" />
                      </span>
                    </div>
                  </el-form-item>
                </el-form>
                <a v-if="!isRegisterAction" class="forget-pwd" href="https://www.8day.com">Quên Mật Khẩu?</a>
                <img class="btn-gif login" v-show="!isRegisterAction" @click="submitAction('2', 'formClient')" src="../assets/new-sport/btn-login.gif" />

                <v-captcha ref="vcaptcha1" :dialogVisible="dialogVisible" :showCheck="showCheck" :style="{
                    width: '300px',
                    height: '50px',
                    position: 'relative',
                  }" @cb="register">
                  <img class="btn-gif" v-show="isRegisterAction" @click="submitAction('1', 'formClient')" src="../assets/new-sport/btn-register.gif" />
                </v-captcha>
              </div>
              <p class="error-msg">{{ errorMsg.content }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="contacts">
        <a :href="fb" target="_blank"><img src="../assets/new-sport/icon-fb.png" /></a>
        <a :href="tg" target="_blank"><img src="../assets/new-sport/icon-tg.png" /></a>
      </div>
    </div>
    <div v-if="isMobile" class="root" @click="clickHandler($event)">
      <img class="gif-air" src="../assets/new-sport/gif-pc.gif" />
      <img class="btn-air" src="../assets/new-sport/btn-main.gif" />
      <div class="mask" v-show="formVisible">
        <div class="form">
          <img class="close" src="../assets/new-sport/icon-close.png" @click="formVisible = false" />
          <div class="form-content">
            <div class="tags">
              <img :class="isRegisterAction ? 'active' : ''" v-show="isRegisterAction" src="../assets/new-sport/icon-reg-a.png" @click="isRegisterAction = true" />
              <img :class="isRegisterAction ? 'active' : ''" v-show="!isRegisterAction" src="../assets/new-sport/icon-reg-n.png" @click="isRegisterAction = true" />
              <img :class="!isRegisterAction ? 'active' : ''" v-show="isRegisterAction" src="../assets/new-sport/icon-login-n.png" @click="isRegisterAction = false" />
              <img :class="!isRegisterAction ? 'active' : ''" v-show="!isRegisterAction" src="../assets/new-sport/icon-login-a.png" @click="isRegisterAction = false" />
            </div>
            <div class="inputs">
              <div class="success-show" v-if="successful">
                <img :src="
                    isRegisterAction
                      ? require('../assets/new-sport/success-reg-h5.png')
                      : require('../assets/new-sport/success-login-h5.png')
                  " />
                <p>
                  {{
                    isRegisterAction
                      ? "* Chúc mừng bạn đã đăng ký thành công! Tự động đăng nhập trong 5s."
                      : "* Bạn đang được chuyển về trang chủ 8day Vui lòng chờ trong 5s."
                  }}
                </p>
              </div>
              <div class="tao" v-if="!successful" :style="isRegisterAction ? '' : 'height: 43%;'">
                <el-form :model="form" ref="formMobile">
                  <el-form-item prop="userName" :rules="userNameRule">
                    <el-input v-model="form.userName" placeholder="Tên đăng nhập" maxlength="20" oninput="value=value.replace(/\W/, '')" autocomplete="off"></el-input>
                  </el-form-item>
                  <el-form-item prop="phone" v-if="isRegisterAction" :rules="isRegisterAction ? phoneRule : null">
                    <el-input v-model="form.phone" placeholder="Số điện thoại" maxlength="11" oninput="value=value.replace(/\D/, '')"></el-input>
                  </el-form-item>
                  <el-form-item prop="password" :rules="passwordRule">
                    <el-input type="password" v-model="form.password" placeholder="Mật khẩu" autocomplete="off"></el-input>
                  </el-form-item>
                  <el-form-item prop="email" v-if="isRegisterAction" :rules="isRegisterAction ? emailRule : null">
                    <el-input v-model="form.email" placeholder="Email"></el-input>
                  </el-form-item>
                  <el-form-item prop="verificationCode" v-show="isRegisterAction" style="position: relative;">
                    <el-input style="background: #acfcef;border-radius: 10px;" v-model="form.verificationCode" maxlength="4"></el-input>
                    <div class="codeImg">
                      <span @click="getVerify" v-if="codeImg" class="validateCode">
                        <img class="img" :src="codeImg" alt="code" />
                      </span>
                    </div>
                  </el-form-item>
                </el-form>
                <a v-if="!isRegisterAction" class="forget-pwd" href="https://www.8day.com">Quên Mật Khẩu?</a>
                <img class="btn-gif login" v-show="!isRegisterAction" @click="submitAction('2', 'formMobile')" src="../assets/new-sport/btn-login-h5.gif" />
                <v-captcha ref="vcaptcha2" :dialogVisible="dialogVisible" :showCheck="showCheck" :style="{
                    width: '300px',
                    height: '50px',
                    position: 'relative',
                    boxSizing: 'border-box',
                    padding: '0 30px'
                  }" @cb="register">
                  <img class="btn-gif" v-show="isRegisterAction" @click="submitAction('1', 'formMobile')" src="../assets/new-sport/btn-reg-h5.gif" />
                </v-captcha>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="contacts">
        <a :href="fb" target="_blank"><img src="../assets/new-sport/icon-fb.png" /></a>
        <a :href="tg" target="_blank"><img src="../assets/new-sport/icon-tg.png" /></a>
      </div>
    </div>
  </div>
</template>

<script>
import { captcha } from "@/mixins/captcha";

import {
  CONTRACTS,
  FORM_VALID_MESSAGE,
  DOMAIN_AGENT_CODE,
  PHONES_PREFIX_FORE,
  PHONES_PREFIX_THREE,
  PHONES_PREFIX_REPLACE
} from "../utils/constant";
import { userRegister, userLogin, createCustomer, getCode } from "../utils/request";
import {
  encodePlatformUrl,
  isMobile,
  validateEmail,
  validatePhone,
  checkPhonePrefix
} from "../utils/tools";
import md5 from "js-md5";

export default {
  name: "NewSport",
  mixins: [captcha],
  data() {
    return {
      codeImg: '',
      formVisible: false,
      successful: false,
      fb: CONTRACTS.facebook,
      tg: CONTRACTS.telegram,
      isMobile: isMobile(),
      dialogVisible: false,
      loading: false,
      isRegisterAction: true,
      errorMsg: {
        title: "",
        content: ""
      },
      form: {
        by: 1,
        username: "",
        verificationCode: "",
        userName: "",
        phone: "",
        password: "",
        email: "",
        link: "",
        domain: "",
        inviteCode: null
      },
      userNameRule: [
        {
          required: true,
          trigger: "change",
          message: FORM_VALID_MESSAGE.emptyMsg
        },
        {
          min: 4,
          max: 20,
          trigger: "change",
          message: FORM_VALID_MESSAGE.usernameFormatErr
        }
      ],
      passwordRule: [
        {
          required: true,
          trigger: "change",
          message: FORM_VALID_MESSAGE.emptyMsg
        },
        {
          min: 6,
          max: 15,
          trigger: "change",
          message: FORM_VALID_MESSAGE.passwordMsg
        }
      ],
      phoneRule: [
        {
          required: true,
          trigger: "change",
          message: FORM_VALID_MESSAGE.emptyMsg
        },
        { validator: validatePhone }
      ],
      emailRule: [
        {
          required: true,
          trigger: "change",
          message: FORM_VALID_MESSAGE.emptyMsg
        },
        { trigger: "change", validator: validateEmail }
      ]
    };
  },
  mounted() {
    window.onresize = () => {
      this.isMobile = isMobile();
    };
    this.getVerify();
  },
  methods: {
    getVerify() {
      getCode({}).then(res => {
        this.codeImg = res.body.data
      })
    },
    submitAction(type, formName) {
      console.log(
        "🚀 ~ file: NewSport.vue:376 ~ submitAction ~ type, formName:",
        type,
        formName
      );
      let that = this;
      this.$refs[formName].validate(valid => {
        if (valid) {
          that.loading = true;
          // 登陆
          if (type == 2) {
            let temp = Object.assign({}, that.form);
            let params = {
              acctType: 6,
              by: 1,
              email: temp.email,
              userName: temp.userName,
              phone: temp.phone,
              password: md5(temp.password)
            };
            that.login(params);
          } else {
            const inviteCode = DOMAIN_AGENT_CODE[location.host] || "";
            that.form.inviteCode = inviteCode;
            that.form.domain = location.host;
            that.form.username = that.form.userName;
            console.log("handleCheckhandleCheckhandleCheckhandleCheck");
            that.handleCheck(that.register);
          }
        }
      });
    },
    login(params) {
      userLogin(params)
        .then(res => {
          if (res.data.code == 0) {
            this.successful = true;
            setTimeout(() => {
              location.href = encodePlatformUrl(
                params.userName,
                params.password
              );
            }, 5000);
          } else {
            this.$notify({
              title: "Error",
              type: "error",
              duration: 2000,
              message: res.data.msg || "Error!"
            });
          }
          this.loading = false;
        })
        .catch(error => {
          this.$notify({
            title: "Error",
            type: "error",
            duration: 2000,
            message: error.data || "Error!"
          });
          this.loading = false;
        });
    },
    register() {
      let params = Object.assign({}, this.form);
      params.userName = this.form.userName.toLowerCase();
      params.password = md5(this.form.password);
      params.phone = this.replacePhonePrefix(this.form.phone);
      params.verificationCode = this.form.verificationCode;
      userRegister(params, this.captchaParams)
        .then(res => {
          if (res.data.code == 0) {
            this.successful = true;
            createCustomer(this.form);
            setTimeout(() => {
              location.href = encodePlatformUrl(
                params.userName,
                params.password
              );
            }, 5000);
          } else {
            this.getVerify();
            this.$notify({
              title: "Error",
              type: "error",
              duration: 2000,
              message: res.data.msg || "Error!"
            });
            this.handleOpen(res.data.code);
          }
          this.loading = false;
        })
        .catch(error => {
          this.$notify({
            title: "Error",
            type: "error",
            duration: 2000,
            message: error.data || "Error!"
          });
          this.loading = false;
        });
    },
    closeDialog() {
      this.dialogVisible = false;
    },
    clickHandler(e) {
      if (
        e.target.className == "content" ||
        e.target.className == "root" ||
        e.target.className == "btn-air"
      ) {
        this.formVisible = true;
      } else if (e.target.className == "close") {
        this.formVisible = false;
      }
    },
    replacePhonePrefix(phone) {
      if (
        phone.length == 11 &&
        PHONES_PREFIX_FORE.includes(phone.substr(0, 4))
      ) {
        return `${PHONES_PREFIX_REPLACE[phone.substr(0, 4)]}${phone.substr(4)}`;
      } else {
        return phone;
      }
    }
  }
};
</script>

<style lang="less" scoped>
::-webkit-input-placeholder {
  color: #000000;
}

.content {
  width: 100%;
  height: calc(100vw * 0.7203125);
  background-image: url("../assets/new-sport/bgi-pc.jpg");
  background-size: 100% 100%;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  position: relative;

  .mask {
    width: 100%;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    background: rgba(0, 0, 0, 0.75);

    .form {
      width: 37.835%;
      height: 72.573%;
      background-image: url("../assets/new-sport/bgi-form.png");
      background-size: 100% 100%;
      position: relative;

      .close {
        width: 50px;
        position: absolute;
        bottom: -80px;
        left: 50%;
        cursor: pointer;
      }

      .form-content {
        width: 515px;
        height: 400px;
        position: absolute;
        bottom: 50px;
        right: 70px;

        .tags {
          width: 90%;
          margin: 0 auto;
          display: flex;
          justify-content: space-between;
          align-items: center;

          img {
            width: 40%;
            cursor: pointer;

            &.active {
              width: 50%;
            }
          }
        }

        .inputs {
          width: 100%;
          height: 100%;

          .tao {
            width: 85%;
            height: 70%;
            margin: 5px auto 0;
            display: flex;
            flex-flow: column;
            align-items: center;
            position: relative;
          }

          /deep/ .el-form {
            width: 100%;

            input {
              height: 55px;
              background: transparent;
              text-indent: 5.5em;
              outline: none;
              border: none;
            }

            .codeImg {
              cursor: pointer;
              width: 150px;
              height: 100%;
              position: absolute;
              right: 0;
              top: 1px;
              .img {
                width: 150px;
                height: 100%;
                border-radius: 20px;
              }
            }

            .el-form-item:first-child .el-input {
              background-image: url("../assets/new-sport/bgi-user.png");
              background-size: 100% 100%;
            }
            .el-form-item:nth-child(2) .el-input {
              background-image: url("../assets/new-sport/bgi-phone.png");
              background-size: 100% 100%;
            }
            .el-form-item:nth-child(3) .el-input {
              background-image: url("../assets/new-sport/bgi-pwd.png");
              background-size: 100% 100%;
            }
            .el-form-item:nth-child(4) .el-input {
              background-image: url("../assets/new-sport/bgi-email.png");
              background-size: 100% 100%;
            }
            .el-form-item:nth-child(5) .el-input {
              background-image: url("../assets/new-sport/bgi-email.png");
              background-size: 100% 100%;
            }
          }

          .forget-pwd {
            position: absolute;
            bottom: -90px;
          }

          .btn-gif {
            width: 370px;
            height: 70px;
            position: absolute;
            bottom: -110px;
            cursor: pointer;

            &.login {
              bottom: -190px;
            }
          }
        }

        .success-show {
          width: 85%;
          height: 70%;
          margin: 5px auto 0;
          display: flex;
          flex-flow: column;
          align-items: center;
          justify-content: center;

          p {
            width: 80%;
            text-align: center;
          }
        }

        p.error-msg {
          width: 100%;
          margin: 0;
          text-align: center;
        }
      }
    }
  }

  @media only screen and (min-width: 1420px) and (max-width: 1680px) {
    .mid {
      height: 500px !important;
      padding-top: 195px !important;
      img {
        width: 100px !important;
        height: 110px !important;
      }
      img.main-register {
        width: 200px !important;
        height: 45px !important;
      }
    }
  }

  .gif-air {
    position: absolute;
    top: 56%;
  }

  .btn-air {
    width: 30%;
    height: 70px;
    position: absolute;
    top: 73%;
    left: 32%;
    cursor: pointer;
  }

  .contacts {
    position: fixed;
    right: 40px;
    top: 90%;

    img {
      margin-right: 10px;
    }
  }
}

.root {
  width: 100%;
  min-height: 100vh;
  height: calc(100vw * 1.9946);
  background-image: url("../assets/new-sport/bgi-h5.jpg");
  background-size: 100% 100%;
  display: flex;
  flex-flow: column;
  align-items: center;
  position: relative;

  .gif-air {
    width: 100%;
    position: absolute;
    top: 59%;
  }

  .btn-air {
    width: 66vw;
    height: 11vw;
    position: absolute;
    top: 69%;
    left: calc(50% - 31vw);
  }

  .mask {
    width: 100%;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;
    display: flex;
    flex-flow: column;
    align-items: center;
    box-sizing: border-box;
    padding-top: 30vw;
    background: rgba(0, 0, 0, 0.75);

    .form {
      width: 100%;
      height: 65vh;
      background-image: url("../assets/new-sport/bgi-form-h5.png");
      background-size: 100% 100%;
      position: relative;

      .close {
        width: 10vw;
        position: absolute;
        left: 47%;
        bottom: -20vw;
      }

      .form-content {
        width: 70%;
        height: 25vh;
        position: absolute;
        left: 19%;
        bottom: 22vh;

        .tags {
          width: 93%;
          margin: 0 auto;
          display: flex;
          justify-content: space-between;

          img {
            width: 40%;

            &.active {
              width: 50%;
            }
          }
        }

        .inputs {
          width: 100%;
          height: 100%;

          .tao {
            width: 85%;
            height: 70%;
            margin: 5px auto 0;
            display: flex;
            flex-flow: column;
            align-items: center;
            position: relative;

            /deep/ .el-form {
              width: 100%;

              input {
                background: transparent;
                text-indent: 3em;
                outline: none;
                border: none;
              }

              .codeImg {
                cursor: pointer;
                width: 150px;
                height: 100%;
                position: absolute;
                right: 0;
                top: 1px;
                .img {
                  width: 150px;
                  height: 100%;
                  border-radius: 20px;
                }
              }

              .el-form-item:first-child .el-input {
                background-image: url("../assets/new-sport/bgi-user.png");
                background-size: 100% 100%;
              }
              .el-form-item:nth-child(2) .el-input {
                background-image: url("../assets/new-sport/bgi-phone.png");
                background-size: 100% 100%;
              }
              .el-form-item:nth-child(3) .el-input {
                background-image: url("../assets/new-sport/bgi-pwd.png");
                background-size: 100% 100%;
              }
              .el-form-item:nth-child(4) .el-input {
                background-image: url("../assets/new-sport/bgi-email.png");
                background-size: 100% 100%;
              }
              .el-form-item:nth-child(5) {
                .el-input {
                  background-image: url("../assets/new-sport/bgi-email.png");
                  background-size: 100% 100%;
                }
                input {
                  text-indent: 0;
                }
              }
            }

            a {
              margin-bottom: 5vw;
            }
          }

          .btn-gif {
            width: 70vw;
            height: 13vw;
          }
        }

        .success-show {
          width: 85%;
          height: 85%;
          margin: 5px auto 0;
          display: flex;
          flex-flow: column;
          align-items: center;
          justify-content: center;

          img {
            width: 80%;
          }
        }
      }
    }
  }

  .contacts {
    position: absolute;
    bottom: 2vw;
    right: 3vw;

    img {
      width: 7vw;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/NewSport.vue